function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask3",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 1,
  width: 25,
  height: 23
}, /*#__PURE__*/React.createElement("path", {
  d: "M11,4 L11,20 L13,20 L13,4 L11,4 Z M14,2 C14.5522847,2 15,2.44771525 15,3 L15,21 C15,21.5522847 14.5522847,22 14,22 L10,22 C9.44771525,22 9,21.5522847 9,21 L9,3 C9,2.44771525 9.44771525,2 10,2 L14,2 Z M22,7 C22.5522847,7 23,7.44771525 23,8 L23,21 C23,21.5522847 22.5522847,22 22,22 L18,22 C17.4477153,22 17,21.5522847 17,21 L17,8 C17,7.44771525 17.4477153,7 18,7 L22,7 Z M6,12 C6.55228475,12 7,12.4477153 7,13 L7,21 C7,21.5522847 6.55228475,22 6,22 L2,22 C1.44771525,22 1,21.5522847 1,21 L1,13 C1,12.4477153 1.44771525,12 2,12 L6,12 Z M21,9 L19,9 L19,20 L21,20 L21,9 Z M5,14 L3,14 L3,20 L5,20 L5,14 Z",
  id: "icon",
  fill: "#333333"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "mask-icon",
  mask: "url(#mask3)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#000"
}));

var SvgReports = function SvgReports(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reports.8a1185e6.svg";
export { ForwardRef as ReactComponent };